import * as Styled from './index.styles';

interface Props {
  currentPage: number;
  totalPages: number;
}

/** 화면 상단 2px 읽기 진행률 바 */
const ProgressBar = ({ currentPage, totalPages }: Props) => {
  const progress = totalPages > 0 ? (currentPage / totalPages) * 100 : 0;

  return (
    <Styled.Track
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalPages}
      aria-valuenow={currentPage}
    >
      <Styled.Fill style={{ width: `${progress}%` }} />
    </Styled.Track>
  );
};

export default ProgressBar;
